// code snippet from dlocal documentation
// https://docs.dlocal.com/api-documentation/payins-api-reference/fraud-prevention#device-id

export const checksum = (string: string): number => {
  let hash = 0;
  const length = string.length;
  if (length === 0) {
    return hash;
  }
  for (let i = 0; i < length; i++) {
    const charCodeAt = string.charCodeAt(i);
    hash = (hash << 5) - hash + charCodeAt;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
};

export const generateDeviceId = (): number => {
  const nav = window.navigator;
  const screen = window.screen;
  let deviceId = `${nav.mimeTypes.length}`;
  Object.values(navigator.mimeTypes).forEach((p) => (deviceId += p.type));
  deviceId += nav.userAgent.replace(/\D+/g, ''); //Only use digits
  deviceId += nav.plugins.length;
  Object.values(navigator.plugins).forEach((p) => (deviceId += p.filename));
  deviceId += screen.height || '';
  deviceId += screen.width || '';
  deviceId += screen.pixelDepth || '';
  return checksum(deviceId);
};
